module.exports = __webpack_public_path__ + "img/Group 1106one4.4e9a005e.png";